/**
 * Data hook for the Operations Dropped surface.
 *
 *   useDropped() — polls GET /api/dropped every 30s. Read-only; cases enter
 *   the drop book upstream (a placement flips to Decision = "Dropped" in
 *   Airtable/the portal/via ops) and never leave (Dropped is terminal).
 *
 * Polls at 30s like the Placed book and Settled book, not the 15s of the
 * routing worklists: a terminal drop book barely moves — a new drop, or a
 * drop letter arriving — so there is nothing to gain from a tight refresh.
 *
 * Spec: engineering/command-center/docs/port-notes/dropped.md (evicted 2026-08-29, #775 round 10)
 */

import { DroppedResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useDropped = createPollingQuery({
  queryKey: ["dropped"] as const,
  path: "/api/dropped",
  schema: DroppedResponseSchema,
  refetchIntervalMs: 30_000,
});
